import { Box } from '@mui/material';
import { FC } from 'react';
import SectionHeader from '@/components/section-header';

interface Props {
  label: string;
}

export const ReadonlySection: FC<Props> = ({ label }) => {
  return (
    <Box mt={1}>
      <SectionHeader title={label} />
    </Box>
  );
};
